/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_Feature_4Inputs */

const en_service_health_nav_landing_feature_4 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health information`)
};

const fr_service_health_nav_landing_feature_4 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information sur la santé`)
};

/**
* | output |
* | --- |
* | "Health information" |
*
* @param {Service_Health_Nav_Landing_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_feature_4 = /** @type {((inputs?: Service_Health_Nav_Landing_Feature_4Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_Feature_4Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_feature_4(inputs)
	return fr_service_health_nav_landing_feature_4(inputs)
});